
import { RevCard } from '@ds/components/Card'
import { mapGetters } from 'vuex'

import {
  getAdvertisingOptionsFromComponent,
  paymentAdvertising,
} from '@payment'

export default {
  components: {
    RevCard,
  },

  computed: {
    ...mapGetters({
      paymentMethods: 'countryConfig/paymentMethods',
    }),

    advertising() {
      return paymentAdvertising(
        'search',
        this.paymentMethods,
        getAdvertisingOptionsFromComponent(this),
      )
    },
  },
}
